import React, { useContext } from 'react';
import '../LoadingConference.css';
import { LangCtx } from "../../../lib/context";

const LoadingConference = (props) => {
    const { l } = useContext(LangCtx);
    // const { instaVC } = useContext(InstavcCtx);
    // const [message, setMessage] = useState(l.instavc_conference_loading);

    // useEffect(() => {
    //     // instaVC.on('load-message', (message) => {
    //     //     setMessage(message);
    //     // });
    //     // return () => {
    //     //     instaVC.off("load-message", () => { });
    //     // }
    // }, [message, instaVC]);

    return <div className="loadingContainerConference">

        <div className="vlContent">
            <div className="vlText">
                <div className="lds-ripple">
                    <div></div>
                    <div></div>
                </div>
            </div>
            <div className="vlTextBlock">
                {/* <p>{message}</p> */}
                <p>{l.instavc_conference_loading}</p>
            </div>
            {/* <div className="vlBtnBlock">
                <div className="btnBothBlock">
                    <div className="btnRightBlock">
                        {(this.state.troubleshoot) && <Button href="/troubleshoot" variant="contained" color="primary" className="capitalizetxt btnPrmFilled">
                            {this.props.language.conference_troubleshoot}
                        </Button>
                        }
                    </div>
                </div>
            </div> */}
        </div>
    </div>
}

export default LoadingConference;